import { useState } from 'react';
import './App.css';
import logo from './img/malt.jpeg'
import pome from './img/pome.png'
import apple from './img/apple.png'
import lemon from './img/lemon.png'
import classic from './img/classic.png'
import { Link } from 'react-router-dom'

function App() {
  const [active, setActive] = useState("flavour")
  const [malActive, setMalActive] = useState("pome")
  const [navShow, setNavShow] = useState(false)
  return (
    <div className={`App ${malActive}`}>
      <div className={`fruitbg ${malActive}`}>
        <div className="nav">
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className={navShow ? `${malActive} navs show` : `${malActive} navs`}>
            <div className="closebtn" onClick={() => setNavShow(false)}>
              <div className="close"></div>
            </div>
            <Link to={""} onClick={() => {setActive("flavour"); setNavShow(false)}} className={active === "flavour" ? "active" : ""}>Flavours</Link>
            <Link to={""} onClick={() => {setActive("find"); setNavShow(false)}} className={active === "find" ? "active" : ""}>Find Us</Link>
            <Link to={""} onClick={() => {setActive("about"); setNavShow(false)}} className={active === "about" ? "active" : ""}>About Us</Link>
            <Link to={""} onClick={() => {setActive("franchise"); setNavShow(false)}} className={active === "franchise" ? "active" : ""}>Franchise</Link>
          </div>
          <button>Online Store</button>
          <div className="hambtn" onClick={() => {setNavShow(true)}}>
            <div className="ham"></div>
          </div>
        </div>
        <div className="body">
          <div className="writeup">
            <h1>NEWS</h1>
            {malActive === "pome" &&
              <> 
                <h2>Pomengranate</h2>
                <p>Pomegranate-Flavored Malt: A Burst of Refreshment
                  Pomegranate, with its vibrant color and rich, tangy flavor, has long been admired for its unique taste and numerous health benefits. Now, imagine combining the distinct sweetness of pomegranate with the crispness of malt, resulting in a delightful fusion of flavors. Enter the world of pomegranate-flavored malt, a beverage that offers a refreshing and invigorating experience.
                  Pomegranate-flavored malt beverages have gained popularity in recent years, appealing to those seeking a refreshing alternative to traditional malt beverages. These drinks typically combine the natural sweetness of pomegranate juice or flavoring with the smoothness of malted grains, creating a harmonious balance of taste and texture.
                </p>
              </>}
            {malActive === "apple" &&
              <>
                <h2>Apple</h2>
                <p>
                  Apple-Flavored Malt: A Crisp and Fruity Delight
                  The taste of a fresh, juicy apple is hard to resist. Its natural sweetness and crisp texture make it a favorite fruit for many. Now, imagine capturing the essence of that delectable apple flavor and infusing it into a refreshing malt beverage. Enter the world of apple-flavored malt, where the tangy and sweet notes of apple combine with the smoothness of malt to create a truly delightful drinking experience.
                  Apple-flavored malt beverages have gained popularity in recent years, offering a unique twist to traditional malt beverages. These drinks typically blend the essence of ripe apples with the richness of malted grains, resulting in a harmonious fusion of flavors that tantalizes the taste buds.
                </p>
              </>}
            {malActive === "classic" &&
              <>
                <h2>Blue Choco</h2>
                <p>Blue Chocolate-Flavored Malt: A Whimsical Twist of Indulgence
                  Indulging in the rich, velvety taste of chocolate is a pleasure enjoyed by many. But what if you could take that experience to a whole new level of whimsy and wonder? Enter the world of blue chocolate-flavored malt, where the enchantment of vibrant blue hue merges with the decadence of chocolate to create a truly delightful and captivating treat.
                  Blue chocolate-flavored malt beverages offer a unique twist on the classic indulgence of chocolate. By infusing the essence of rich cocoa with a touch of mesmerizing blue coloring, these drinks bring an element of excitement and playfulness to the table.
                  As you take your first sip of a blue chocolate-flavored malt, you'll be transported to BLISS
                </p>
              </>}
            {malActive === "lemon" &&
              <>
                <h2>Lemon</h2>
                <p>Lemon-Flavored Malt: A Zesty Burst of Refreshment
                  The bright and tangy taste of lemon has long been cherished for its ability to invigorate and refresh the senses. Now, imagine infusing that zesty citrus flavor into a crisp and delightful malt beverage. Welcome to the world of lemon-flavored malt, where the vibrant essence of lemon combines with the smoothness of malt to create a truly refreshing and revitalizing drink.
                  Lemon-flavored malt beverages have gained popularity for their ability to offer a unique twist to traditional malt beverages. By blending the vibrant and tangy notes of lemon with the mellow character of malted grains, these drinks provide a harmonious fusion of flavors that awaken your taste buds.
                </p>
              </>}

            <div className="drinka">
              <Link to={""} onClick={() => setMalActive("pome")} className={malActive === "pome" ? "active" : ""}><img src={pome} alt="" /></Link>
              <Link to={""} onClick={() => setMalActive("apple")} className={malActive === "apple" ? "active" : ""}><img src={apple} alt="" /></Link>
              <Link to={""} onClick={() => setMalActive("classic")} className={malActive === "classic" ? "active" : ""}><img src={classic} alt="" /></Link>
              <Link to={""} onClick={() => setMalActive("lemon")} className={malActive === "lemon" ? "active" : ""}><img src={lemon} alt="" /></Link>
            </div>
          </div>
          <div className="drink">
            <div className="move">
            <div className={`circle ${malActive}`}>
              <img src={pome} alt="" className='pome' />
              <img src={apple} alt="" className='apple' />
              <img src={classic} alt="" className='classic' />
              <img src={lemon} alt="" className='lemon' />
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
